import Vue from "vue";
import VueResource from "vue-resource";
import ElementUI from "element-ui";
import 'vant/lib/index.css';
import "element-ui/lib/theme-default/index.css";
import littleHint from "./heaperJs/wg-littleHint.js";
import animated from "animate.css";
import infiniteScroll from "vue-infinite-scroll";
import router from "./router/index.js";
import md5 from "js-md5";
import store from "./store/index.js"
Vue.use(infiniteScroll);
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(animated);
import common from "./components/util/common.js";
import courseView from "./components/util/pm_course_play_view.js";
import stmp from "./components/util/stmp.js";
import api from "./request/api/index.js";//api统一入口
import jWeixin from "weixin-js-sdk";
import { Dialog, Toast } from 'vant';
import Vconsole from "vconsole";
Vue.use(Dialog)
Vue.use(Toast);
Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response.body.status == 1 && response.body.errcode == 407) {
      //跳去限流的页面哦
      window.location.href = "/appstatic/cmtapp/#/errorPage";
    }
    return response;
  });
});
window.jQuery = $;
window.$ = $;
Vue.prototype.$littleHint = littleHint;
Vue.config.debug = true;
// 微信开放标签由微信 JS-SDK 在运行时接管，不属于 Vue 组件。
// 如果不加入 ignoredElements，Vue 2 会把 <wx-open-launch-app> 当作未注册组件并报警：
// Unknown custom element: <wx-open-launch-app>。
Vue.config.ignoredElements = (Vue.config.ignoredElements || []).concat(["wx-open-launch-app"]);
Vue.prototype.reqUrl = window.location.origin;

if (process.env.NODE_ENV != "production") {
  let vConsole = new Vconsole();
  Vue.prototype.reqUrl = "https://admins.medtrib.cn";
}
Vue.prototype.skey = "gG2GgksqJPcQLXVTmbx7sxxnhO3Jgs";
Vue.prototype.md5 = md5;
Vue.prototype.common = common;
Vue.prototype.courseView = courseView;
Vue.prototype.stmp = stmp;
Vue.prototype.checkBindWx = 1;
// weixin-js-sdk 已升级到 1.6.5，支持 openTagList 且可被当前 webpack2/UglifyJS 压缩。
console.log(jWeixin, 'jWeixin')
Vue.prototype.wx = jWeixin;
Vue.prototype.$api = api;
const App = (resolve) => require(["./app.vue"], resolve);

common.setFontSize();

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  next();
});

Vue.filter("formatDate", function (stamp, type) {
  const now = new Date(parseInt(stamp));
  const year = now.getFullYear();
  const month = now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
  const day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
  const hour = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
  const minute = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
  const second = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
  if (type == "HM") {
    return hour + ":" + minute;
  } else if (type == "MDHM") {
    return month + "-" + day + " " + hour + ":" + minute;
  } if (type == 'yyyy-MM-dd') {
    return year + "-" + month + "-" + day;
  } else {
    return year + "-" + month + "-" + day + " " + hour + ":" + minute;
  }
});
Vue.directive("focus", {
  inserted: function (el, { value }) {
    if (value) {
      el.focus();
    }
  },
});
let vm = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
})
export default vm;



// WEBPACK FOOTER //
// ./src/cmtapp/index.js